module.exports = {
      id: "bath-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#bath-usage",
      toString: function () {
        return this.url;
      }
    }